import { render, staticRenderFns } from "./Punchprint.vue?vue&type=template&id=908016f8"
import script from "./Punchprint.vue?vue&type=script&lang=js"
export * from "./Punchprint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports